// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yQp8jnTsJdhGF1OtPuyT {
  max-height: 26px;
  overflow-y: auto;
}

.yQp8jnTsJdhGF1OtPuyT::-webkit-scrollbar {
  -webkit-appearance: none;
}

.yQp8jnTsJdhGF1OtPuyT::-webkit-scrollbar-thumb {
  background-color: #58bcc9;
  border: 2px solid white;
  border-radius: 8px;
}

.yQp8jnTsJdhGF1OtPuyT::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}

.yQp8jnTsJdhGF1OtPuyT::-webkit-scrollbar:vertical {
  width: 11px;
}

.v5L4rCyfSxxo0rq3kRoP {
  margin: 2px 4px 2px 0 !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/categories/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".tag_wrapper {\n  max-height: 26px;\n  overflow-y: auto;\n}\n\n.tag_wrapper::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.tag_wrapper::-webkit-scrollbar-thumb {\n  background-color: #58bcc9;\n  border: 2px solid white;\n  border-radius: 8px;\n}\n\n.tag_wrapper::-webkit-scrollbar-track {\n  background-color: #fff;\n  border-radius: 8px;\n}\n\n.tag_wrapper::-webkit-scrollbar:vertical {\n  width: 11px;\n}\n\n.tag {\n  margin: 2px 4px 2px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag_wrapper": `yQp8jnTsJdhGF1OtPuyT`,
	"tag": `v5L4rCyfSxxo0rq3kRoP`
};
export default ___CSS_LOADER_EXPORT___;
